export const ADMIN = "admin";
export const CENTRE_ADMIN = "centre_admin";
export const EXECUTIVE_CENTRE_ADMIN = "executive_centre_admin";
export const MARKETING = "marketing";
export const TELEHEALTH_MANAGER = "telehealth_manager";
export const TELEHEALTH_ADMIN = "telehealth_admin";

export const ROUTES = {
	main: "/",
	ourmedicalBlogs: "/ourmedicalBlogs",
	ourmedicalBlogsEdit: "/ourmedicalBlogEdit",
	oursageBlogs: "/oursageBlogs",
	oursageBlogEdit: "/oursageBlogEdit",
	oursageLogs: "/oursageLogs",
	clinicSettings: "/clinicSettings",
	telehealthCentres: "/telehealthCentres",
	doctors: "/doctors",
	doctorEdit: "/doctorEdit",
	noAccess: "/noAccess",
	telehealthQueue: "/telehealthQueue",
	telehealthDoctors: "/telehealthDoctors",
	auditLogs: "/auditLogs",
	doctorAdmin: "/doctorAdmin",
	centreOperations: "/centreOperations",
	holidays: "/holidays",
	telehealthSchedules: "/telehealthSchedules",
	patientSearch: "/patientsearch",
	bannedPatientMessage: "/bannedPatientMessage",
	appVersions: "/appVersions"
};

// Example role-based access map
export const ROUTE_ROLES = {
	[ROUTES.ourmedicalBlogs]: [
		ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		MARKETING,
		"reader"
	],
	[ROUTES.ourmedicalBlogsEdit]: [ADMIN, EXECUTIVE_CENTRE_ADMIN, MARKETING],
	[ROUTES.oursageBlogs]: [ADMIN, EXECUTIVE_CENTRE_ADMIN, MARKETING, "reader"],
	[ROUTES.oursageBlogEdit]: [ADMIN, EXECUTIVE_CENTRE_ADMIN, MARKETING],
	[ROUTES.oursageLogs]: [ADMIN, "reader"],
	[ROUTES.clinicSettings]: [ADMIN],
	[ROUTES.appVersions]: [ADMIN],
	[ROUTES.telehealthCentres]: [
		ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		TELEHEALTH_MANAGER
	],
	[ROUTES.centreOperations]: [
		ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		"centre_admin_annerley",
		"centre_admin_ashmore",
		"centre_admin_carolinesprings",
		"centre_admin_cranbourne",
		"centre_admin_crowsnest",
		"centre_admin_deewhy",
		"centre_admin_goldcoast",
		"centre_admin_gregoryhills",
		"centre_admin_kellyville",
		"centre_admin_loganholme",
		"centre_admin_marsdenpark",
		"centre_admin_morayfield",
		"centre_admin_northlakes",
		"centre_admin_oakleigh",
		"centre_admin_penrith",
		"centre_admin_test",
		"centre_admin_williamslanding",
		CENTRE_ADMIN
	],
	[ROUTES.doctorAdmin]: [
		ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		TELEHEALTH_MANAGER,
		TELEHEALTH_ADMIN,
		"centre_admin_annerley",
		"centre_admin_ashmore",
		"centre_admin_carolinesprings",
		"centre_admin_cranbourne",
		"centre_admin_crowsnest",
		"centre_admin_deewhy",
		"centre_admin_goldcoast",
		"centre_admin_gregoryhills",
		"centre_admin_kellyville",
		"centre_admin_loganholme",
		"centre_admin_marsdenpark",
		"centre_admin_morayfield",
		"centre_admin_northlakes",
		"centre_admin_oakleigh",
		"centre_admin_penrith",
		"centre_admin_test",
		"centre_admin_williamslanding",
		CENTRE_ADMIN
	],
	[ROUTES.doctorEdit]: [
		ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		TELEHEALTH_MANAGER,
		TELEHEALTH_ADMIN,
		"centre_admin_annerley",
		"centre_admin_ashmore",
		"centre_admin_carolinesprings",
		"centre_admin_cranbourne",
		"centre_admin_crowsnest",
		"centre_admin_deewhy",
		"centre_admin_goldcoast",
		"centre_admin_gregoryhills",
		"centre_admin_kellyville",
		"centre_admin_loganholme",
		"centre_admin_marsdenpark",
		"centre_admin_morayfield",
		"centre_admin_northlakes",
		"centre_admin_oakleigh",
		"centre_admin_penrith",
		"centre_admin_test",
		"centre_admin_williamslanding",
		CENTRE_ADMIN
	],
	[ROUTES.telehealthQueue]: [
		ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		TELEHEALTH_ADMIN,
		TELEHEALTH_MANAGER
	],
	[ROUTES.telehealthDoctors]: [
		ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		TELEHEALTH_ADMIN,
		TELEHEALTH_MANAGER
	],
	[ROUTES.auditLogs]: [
		ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		TELEHEALTH_MANAGER,
		CENTRE_ADMIN
	],
	[ROUTES.holidays]: [
		ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		CENTRE_ADMIN,
		"centre_admin_annerley",
		"centre_admin_ashmore",
		"centre_admin_carolinesprings",
		"centre_admin_cranbourne",
		"centre_admin_crowsnest",
		"centre_admin_deewhy",
		"centre_admin_goldcoast",
		"centre_admin_gregoryhills",
		"centre_admin_kellyville",
		"centre_admin_loganholme",
		"centre_admin_marsdenpark",
		"centre_admin_morayfield",
		"centre_admin_northlakes",
		"centre_admin_oakleigh",
		"centre_admin_penrith",
		"centre_admin_test",
		"centre_admin_williamslanding"
	],
	[ROUTES.telehealthSchedules]: [
		ADMIN,
		CENTRE_ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		TELEHEALTH_MANAGER
	],
	[ROUTES.patientSearch]: [
		ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		TELEHEALTH_MANAGER,
		TELEHEALTH_ADMIN,
		"centre_admin_annerley",
		"centre_admin_ashmore",
		"centre_admin_carolinesprings",
		"centre_admin_cranbourne",
		"centre_admin_crowsnest",
		"centre_admin_deewhy",
		"centre_admin_goldcoast",
		"centre_admin_gregoryhills",
		"centre_admin_kellyville",
		"centre_admin_loganholme",
		"centre_admin_marsdenpark",
		"centre_admin_morayfield",
		"centre_admin_northlakes",
		"centre_admin_oakleigh",
		"centre_admin_penrith",
		"centre_admin_test",
		"centre_admin_williamslanding"
	],
	[ROUTES.bannedPatientMessage]: [
		ADMIN,
		EXECUTIVE_CENTRE_ADMIN,
		TELEHEALTH_MANAGER,
		TELEHEALTH_ADMIN,
		"centre_admin_annerley",
		"centre_admin_ashmore",
		"centre_admin_carolinesprings",
		"centre_admin_cranbourne",
		"centre_admin_crowsnest",
		"centre_admin_deewhy",
		"centre_admin_goldcoast",
		"centre_admin_gregoryhills",
		"centre_admin_kellyville",
		"centre_admin_loganholme",
		"centre_admin_marsdenpark",
		"centre_admin_morayfield",
		"centre_admin_northlakes",
		"centre_admin_oakleigh",
		"centre_admin_penrith",
		"centre_admin_test",
		"centre_admin_williamslanding"
	]
};
